<div class="grid-container">
  <div class="card">
    <div class="card-title"><p>Uso de DISCO</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M6 4h10l4 4v10a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2v-12a2 2 0 0 1 2 -2"
          ></path>
          <path d="M12 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
          <path d="M14 4l0 4l-6 0l0 -4"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.diskUsagePercentage }}%</div>
    </div>
  </div>
  <div class="card">
    <div class="card-title"><p>Uso de de CPU</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M5 5m0 1a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v12a1 1 0 0 1 -1 1h-12a1 1 0 0 1 -1 -1z"
          ></path>
          <path d="M9 9h6v6h-6z"></path>
          <path d="M3 10h2"></path>
          <path d="M3 14h2"></path>
          <path d="M10 3v2"></path>
          <path d="M14 3v2"></path>
          <path d="M21 10h-2"></path>
          <path d="M21 14h-2"></path>
          <path d="M14 21v-2"></path>
          <path d="M10 21v-2"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.cpuUsagePercentage }}%</div>
    </div>
  </div>
  <div class="card">
    <div class="card-title"><p>Uso de RAM:</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path d="M4 8h4v4h-4z"></path>
          <path d="M6 4l0 4"></path>
          <path d="M6 12l0 8"></path>
          <path d="M10 14h4v4h-4z"></path>
          <path d="M12 4l0 10"></path>
          <path d="M12 18l0 2"></path>
          <path d="M16 5h4v4h-4z"></path>
          <path d="M18 4l0 1"></path>
          <path d="M18 9l0 11"></path>
        </svg>
      </div>
      <div class="card-value">{{ currentInfo?.memoryUsagePercentage }}%</div>
    </div>
  </div>
  <div class="card">
    <div class="card-title"><p>Conexiones Fallidas</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M12 18.004h-5.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99a3.45 3.45 0 0 1 2.756 1.373"
          ></path>
          <path d="M19 19m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"></path>
          <path d="M17 21l4 -4"></path>
        </svg>
      </div>
      <div class="card-value">
        {{
          currentInfo?.mysqlStats?.abortedConnects?.toLocaleString()
            | number : "1.0-0"
        }}
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-title"><p>Consultas Totales</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M17.73 19.875a2.225 2.225 0 0 1 -1.948 1.125h-7.283a2.222 2.222 0 0 1 -1.947 -1.158l-4.272 -6.75a2.269 2.269 0 0 1 0 -2.184l4.272 -6.75a2.225 2.225 0 0 1 1.946 -1.158h7.285c.809 0 1.554 .443 1.947 1.158l3.98 6.75a2.33 2.33 0 0 1 0 2.25l-3.98 6.75v-.033z"
          ></path>
          <path
            d="M11.5 11.5m-3.5 0a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0 -7 0"
          ></path>
          <path d="M14 14l2 2"></path>
        </svg>
      </div>
      <div class="card-value">
        {{ currentInfo?.mysqlStats?.queries | number : "1.0-0" }}
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-title"><p>Conexiones</p></div>
    <div class="card-info">
      <div class="card-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#368DB7"
          stroke-linecap="round"
          stroke-linejoin="round"
          width="45"
          stroke-width="1.5"
        >
          <path
            d="M11 18.004h-4.343c-2.572 -.004 -4.657 -2.011 -4.657 -4.487c0 -2.475 2.085 -4.482 4.657 -4.482c.393 -1.762 1.794 -3.2 3.675 -3.773c1.88 -.572 3.956 -.193 5.444 1c1.488 1.19 2.162 3.007 1.77 4.769h.99c1.388 0 2.585 .82 3.138 2.007"
          ></path>
          <path d="M15 19l2 2l4 -4"></path>
        </svg>
      </div>
      <div class="card-value">
        {{ currentInfo?.mysqlStats?.connections | number : "1.0-0" }}
      </div>
    </div>
  </div>
</div>
